import api from '@services/api';
import { PaginationResponse } from '../models/pagination';
import { Position, PositionSearchInput } from '../models/position';

/**
 * <p>
 * API endpoints that cover all Position related CRUD calls
 */

export const PositionsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    searchPositions: builder.query<PaginationResponse<Position>, PositionSearchInput>({
      query: (input: PositionSearchInput) => ({
        url: encodeURI(
          `/indirect/position/search?searchTerm=${input.searchTerm}&page=${input.page}&size=${input.size}&sortKey=${input.sortKey}&sortDirection=${input.sortDirection}`,
        ),
      }),
      providesTags: ['Positions'],
    }),
  }),
});

export const { useSearchPositionsQuery } = PositionsApi;
